import { useShallow } from 'zustand/react/shallow';

import { useProgressDialogStore } from 'stores/progressDialogStore';

export const useProgressDialog = () => {
  const state = useProgressDialogStore(
    useShallow(({ isVisible, text }) => ({ isVisible, text })),
  );
  const show = useProgressDialogStore(state => state.show);
  const hide = useProgressDialogStore(state => state.hide);

  return { state, show, hide };
};
